<template>
    <div class="personal-certificate" v-loading="loading">
        <module-title title="我的培训班"></module-title>
        <div class="cer_list_box course_news_box ">
            <el-table
                :data="list"
                border
                style="width: 100%">
                <el-table-column
                    prop="trainCategoryName"
                    label="培训班名称"
                    >
                    <template #default="scope">
                        <span @click="checkTrainCategoryName(scope.row)">{{ scope.row.trainCategoryName }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="classTime"
                    label="报名时间"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="bxkCredit"
                    label="必修学时">
                </el-table-column>
                <el-table-column
                    prop="xxkCredit"
                    label="选修学时">
                </el-table-column>
                <el-table-column
                    prop="uploadStatus"
                    label="上传结果">

                </el-table-column>
            </el-table>
            <!-- <div style="margin-top:20px;color:#606266">
                说明：请检查身份证号、岗位证书号与专业课系统中一致，学习成绩会在4月统一上传。<br>
                <p style="color:#ff0000;font-weight: bold;">请大家登录厅专业课平台，查看是否上传成功。</p><br>
                学习完成后，一定要在 <span  target="_blank" @click="enteCer" style="color: #10aeff;cursor: pointer;">证书管理</span>
                中完善证书信息，删除不正确的，添加正确的
            </div> -->
            <!-- 分页器 -->
            <div class="block page_box mtop20" v-if="total>1">
                <el-pagination
                    layout="prev, pager, next"
                    :page-size="page.size"
                    :background="true"
                    :total="page.total"
                    @current-change="handleCurrentChange"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import ModuleTitle from "@/components/common/moduleTitle/ModuleTitle";
import { PcCookie, Key } from "@/utils/cookie";
import { myTrainClassList, checkTrainStatus } from "api/personal"
export default {
    components:{ ModuleTitle },
    computed:{
        noMessage() {
            return this.page.total == 0 ? true : false;
        },
    },
    data(){
        return{
            loading:false,
            sessionId:PcCookie.get(Key.jsessIdKey),
            page: {
                current: 1,
                size: 10,
                total: 0,
            },
            list:[],
        }
    },
    async created(){
        this.loading = true;
        await this.fetchList();
        this.loading = false;
    },
    methods:{
        checkTrainCategoryName(row){
            console.log(row,"-----")
            checkTrainStatus(this.sessionId,row.trainCategoryId).then(res => {
                console.log(res)
                if(res.errorCode == '2000'){
                    this.$router.push({
                        path:'/pcViews/learn/train-details',
                        query:{
                            trainId:row.trainSingupId
                        }
                    })
                }
                if(res.errorCode == '3003'){
                    this.$message({
                        message: res.msg,
                        type: "error",
                    });
                }
            })
        },
        enteCer(){
            this.$router.push('/pcViews/personal/certificate')
        },
        handleCurrentChange(val){
            this.page.current = val;
            this.fetchCertIssueLis();
        },
        //获取证书列表
        fetchList(){
            myTrainClassList(this.sessionId,this.page.current,
                this.page.size).then(res => {
                if (res.errorCode === "2000") {
                    this.list = res.body.data.rows;
                    this.page.total = res.body.data.total;
                }
            })
        },
    }
}
</script>
<style scoped>
.noMessage {
    height: 120px;
    line-height: 120px;
    font-size: 16px;
    color: #818181;
    text-align: center;
}
</style>
